export const clamp = (value: number, low: number, high: number) => {
  return Math.max(low, Math.min(high, value));
};
